import { useMutation } from '@apollo/client'
import { IMPERSONATE_B2B_CUSTOMER } from '@/containers/B2BCustomers/B2BCustomersQueries'
import { useCallback, useEffect } from 'react'
import { useLanguage } from '@/context/LanguageContext'
import { jwtDecode } from 'jwt-decode'

const useImpersonateB2BCustomer = () => {
  const [impersonateLazy, { loading, error, data }] = useMutation(
    IMPERSONATE_B2B_CUSTOMER,
    {
      fetchPolicy: 'network-only',
    }
  )
  const { webAddress } = useLanguage()
  //const webAddress = 'http://localhost:2000' //process.env.REACT_APP_WEB_URL; --- IGNORE ---

  const getCurrentUserId = () => {
    const token = localStorage.getItem('furnisystems-token')
    if (!token) return null
    try {
      const decoded = jwtDecode(token) as any
      console.log('Decoded JWT:', decoded)
      return decoded.id // Assuming the JWT has 'id' field for user ID
    } catch (e) {
      return null
    }
  }

  const impersonate = useCallback(
    (customerId: number) => {
      const managerId = getCurrentUserId()
      if (!managerId) {
        console.error('Unable to get current user ID')
        return
      }
      impersonateLazy({
        variables: {
          impersonateB2BCustomerId: customerId,
          managerId,
        },
      })
    },
    [impersonateLazy]
  )

  useEffect(() => {
    if (data) {
      const url = `${webAddress}/login?token=${data.impersonateB2BCustomer}`
      window.open(url, '_blank', 'noreferrer')
    }
  }, [data])

  return { impersonate, loading, error, data }
}

export default useImpersonateB2BCustomer
